import i18n from "../language/index"; // Internationalization

export default function getPageTitle() {
  return `${i18n.t("openConfig.title")}`;
}
